// item 559 — the grids' APPROVED BY column, one rule for every module: client
// approval via the public email link wins (the e-signature name the client typed;
// 'Client' when the click predates name capture); otherwise the Basix user whose
// Approve/Process moved the (source) proposal to Approved. WO/invoice rows inherit
// these fields from their source proposal server-side. Undefined = not approved yet.
export interface ApproverFields {
  clientApprovedDate?: string | null;
  clientApprovedByName?: string | null;
  approvedByName?: string | null;
}

export const approverOf = (row: ApproverFields): string | undefined => {
  if (row.clientApprovedDate) return row.clientApprovedByName || 'Client';
  return row.approvedByName || undefined;
};
